import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { ChildBase } from '@unicorn/sdui';
import { createSduiTicket } from '../../../../models/detail-sdui';
import * as Styled from '../../styled';

export const ActionsCreate = ({
  valid,
  sduiData,
  onCreateCancel,
}: {
  valid: boolean;
  sduiData: ChildBase[];
  onCreateCancel: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <Styled.Actions>
      <Styled.ActionsLeft>
        <Button
          disabled={!valid}
          onClick={() => createSduiTicket(sduiData)}
          startIcon={<CheckIcon />}
          variant="contained"
        >
          {t('Save')}
        </Button>

        <Button onClick={onCreateCancel} variant="outlined" startIcon={<CloseIcon />}>
          {t('cancel')}
        </Button>
      </Styled.ActionsLeft>
    </Styled.Actions>
  );
};
